// extracted by mini-css-extract-plugin
export var cardSelected = "_id-2";
export var image = "_id-1";
export var table = "_id-0";